import React, { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";

import FInput from "../../components/FInput/FInput";
import { useFormik } from "formik";
import { postCards } from "../../api/cards";
import { useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { getAddress } from "../../api/address";
import { getcontactInfo } from "../../api/contactInfo";
import * as Yup from "yup";
import { useRegex } from "../../hooks/useRegex";
import { useAddress } from "../../hooks/useAddress";
import { useContactInfo } from "../../hooks/useContactInfo";
import Select from "react-select";
import { PlusCircleIcon } from "@heroicons/react/outline";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
// import required modules
import { EffectCoverflow, Pagination } from "swiper";

import FInputt from "../../components/FInputt/FInputt";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import FContainer from "../../components/FContainer/FContainer";
import FInputText from "../../components/Finputs/FInputText/FInputText";
import { LocationOutline, MailOutline } from "react-ionicons";
import FBannerTitleSubTitle from "../../components/FspendComponents/FBannerSpend/FBannerTitleSubTitle";
import FAddressCard from "../../components/FAddressCard/FAddressCard";
import Fselect from "../../components/Finputs/Fselect/Fselect";
import { useCards } from "../../hooks/useCards";

import { AddCircleOutline } from "react-ionicons";
import Swal from "sweetalert2";

const CreateCardScreen = () => {
  const { alphaWithSpaces } = useRegex();
  const [selectCard, setSelectCard] = useState(null);
  const { addresses, getAddresses } = useAddress();
  const { emails, getEmails, emailMapSelect } = useContactInfo();
  const { createCard, consultCard } = useCards();



  const [indexInfo, setIndexInfo] = useState(0);
  const route = useNavigate();

  const { pathname, previousScreenDefinite, setPreviousScreenDefinite,createCardFlux,dispatchCreateCardFlux } = useContext(AuthContext);
  useEffect(() => {
    getAddresses();
    setInitialValues();
    getEmails();
  }, []);

  const [addressId2, setAddressId2] = useState(addresses[0]?.address.id);

  useEffect(() => {
    setAddressId2(addresses[0]?.address.id);
    setFieldValue("addressId", addresses.length > 0 ? addresses[0].address.id : "");
  }, [addresses]);

  useEffect(() => {
    setFieldValue(
      "contactInfoId",
      emailMapSelect.length > 0 ? emailMapSelect[0].id : ""
    );
  }, [emailMapSelect]);


  const setInitialValues = ()=>{

    // let object = {
    //   pan: "",
    //   expirationMonth:"",
    //   expirationYear:"",
    //   name:"",
    //   lastName:""
    // }

    // try{
    //   object.pan = 
    //   object.expirationMonth =;
    //   object.expirationYear = ;
    //   object.name = JSON.parse(localStorage.getItem("createCardScreenData"))?.name;
    //   object.lastName = JSON.parse(localStorage.getItem("createCardScreenData"))?.lastName;
    //   console.log(object)
    // }catch(e){
    //   console.log('falla')
    // }

      setFieldValue("pan",  createCardFlux.pan);
      setFieldValue("expirationMonth",createCardFlux.expirationMonth);
      setFieldValue("expirationYear",createCardFlux.expirationYear  );
      setFieldValue("name", createCardFlux.name );
      setFieldValue("lastName", createCardFlux.lastName );
    
  }

  const validMonths = (month) => {
    let months = [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
    ];
    let monthInArray = months.filter((element) => element == month);
    if (monthInArray.length > 0) {
      const date = new Date();
      const month = date.getMonth() + 1;
      const actualMonth = month < 10 ? `0${month}` : month;
      const year = date.getFullYear();
      const actualYear = year.toString().substring(2, 4);

      //console.log(targetYear)

      if (
        monthInArray[0] < actualMonth &&
        values.expirationYear == actualYear
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      //console.log(month)
      return false;
    }
  };

  const validYear = (year) => {
    let actualYear = parseInt(new Date().getFullYear().toString().substring(2));
    let cardYear = parseInt(year);
    if (year == undefined) {
      return false;
    }
    if (cardYear < actualYear || cardYear - actualYear > 20) {
      return false;
    }
    return true;
  };

  const validPan = (pan) => {
    if (!pan){
      return false;
    } else{
      if (pan.substr(0,1) != "3" && pan.length < 16){
        return false;
      }
      if (pan.substr(0,1) == "3" && pan.length < 15){
        return false;
      }
    }
    return true;
  };



  const validate = Yup.object({
    pan: Yup.string()
      // .min(16, "Ingrese un número de tarjeta válido")
      .required("Este campo es requerido").test(
        "",
        "Ingrese un número de tarjeta válido",
        (value) => validPan(value) == true
      ),
    expirationMonth: Yup.string().test(
      "Valid Month",
      "Mes no válido",
      (value) => validMonths(value) == true
    ),
    expirationYear: Yup.string().test(
      "Valid Year",
      "Tarjeta vencida",
      (value) => validYear(value) == true
    ),
    contactInfoId: Yup.string().required("Este campo es requerido"),
    name: Yup.string()
      .required("Este campo es requerido")
      .matches(alphaWithSpaces, "El nombre capturado no es válido"),
    lastName: Yup.string()
      .required("Este campo es requerido")
      .matches(alphaWithSpaces, "El apellido no es válido."),
  });

  const nextScreen = async (data) => {
    
    const consult = await consultCard(data.pan);
    if (consult.code == "PROCESS_OK") {
      Swal.fire({
        showCloseButton: true,
        title: 'Advertencia',
        text: "El número de tarjeta ya fue registrada",
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#fd6e0d',
        iconColor: "#fd6e0d",
        confirmButtonText: 'Entendido'
      }).then((result) => {
        if (result.isConfirmed) {
          setFieldValue("pan", "")
        }
      });
    } else {
      const res = await createCard(data);
      if (res) {
        dispatchCreateCardFlux({})
        route(-1);
      }
    }

  };

  const { values, setFieldValue, handleSubmit, errors, dirty, isValid } =
    useFormik({
      initialValues: {
        pan: "",
        expirationYear: "",
        expirationMonth: "",
        contactInfoId: "",
        name: "",
        lastName: "",
      },
      onSubmit: (values) => {
        const data = {
          pan: values.pan,
          expirationYear: values.expirationYear,
          expirationMonth: values.expirationMonth,
          addressId: addressId2,
          contactInfoId: values.contactInfoId,
          cardHolder: {
            name: values.name,
            lastName: values.lastName,
          },
        };
        nextScreen(data);
      },

      validationSchema: validate,
    });


    const saveState = async()=>{
      
      let cardsData = {
        pan: values.pan,
        expirationYear: values.expirationYear,
        expirationMonth: values.expirationMonth,
        contactInfoId: values.contactInfoId,
        name: values.name,
        lastName: values.lastName,
      }

      dispatchCreateCardFlux(cardsData)

    }

  return (
    <>
      <FBannerTitleSubTitle
        title="Método de pago"
        subTitle="Agrega los datos de tu tarjeta"
        imageUrl={require("../../components/assets/images/credit-card.png")}
      />
      <FContainer>
        <div className="border-0 w-full grid grid-cols-1">
          <div className="border-0 col-span-1">
            <FInputText
              value={createCardFlux.pan ? createCardFlux.pan : values.pan}
              type="NumberCardInput"
              maxLength={values?.pan?.substr(0,1) == "3" ? 15 : 16}
              placeholder="Número de la tarjeta"
              title="Número de la tarjeta"
              onChange={(value) => {
                setFieldValue("pan", value);
              }}
              errorMessage={!values.pan ? "" : errors.pan}
            />
          </div>
          <div className="border-0 col-span-1 grid grid-cols-2">
            <div className="border-0 col-span-1 pr-1">
              <FInputText
              value={createCardFlux.expirationMonth ? createCardFlux.expirationMonth : values.expirationMonth}
                type="NumberInput"
                title="Mes (MM)"
                maxLength={2}
                placeholder="Mes de exp"
                onChange={(value) => {
                  setFieldValue("expirationMonth", value);
                }}
                errorMessage={!values.expirationMonth ? "" : errors.expirationMonth}
              />
            </div>
            <div className=" border-0 col-span-1 pl-1">
              <FInputText
                value={createCardFlux.expirationYear ? createCardFlux.expirationYear : values.expirationYear}
                type="NumberInput"
                title="Año (AA)"
                maxLength={2}
                placeholder="Año de exp"
                onChange={(value) => {
                  setFieldValue("expirationYear", value);
                }}
                errorMessage={!values.expirationYear ? "" : errors.expirationYear}

              />
            </div>
          </div>
          <div className="border-0 col-span-1">
            <FInputText
              value={createCardFlux.name ? createCardFlux.name : values.name}
              placeholder="Nombres"
              title="Nombres"
              onChange={(value) => {
                setFieldValue("name", value);
              }}
              errorMessage={!values.name ? "" : errors.name}
            />
          </div>
          <div className="border-0 col-span-1">
            <FInputText
              value={createCardFlux.lastName ? createCardFlux.lastName : values.lastName}
              placeholder="Apellidos"
              title="Apellidos"
              onChange={(value) => {
                setFieldValue("lastName", value);
              }}
              errorMessage={!values.lastName ? "" : errors.lastName}
            />
          </div>
          {addresses.length > 0 ? (
            <div className="border-0 col-span-1 py-5">
              <Swiper
                effect={"coverflow"}
                grabCursor={true}
                centeredSlides={true}
                slidesPerView={1}
                edgeSwipeThreshold={20}
                // pagination={true}
                coverflowEffect={{
                  rotate: 10,
                  stretch: 5,
                  depth: 50,
                  modifier: 3,
                  slideShadows: false,
                }}
                modules={[EffectCoverflow, Pagination]}
                className="absolute w-full h-full border-0 rounded-r-3xl"
                onSlideChange={(e) => {
                  setFieldValue("addressId", addresses.address[e.realIndex].id);
                  setSelectCard({
                    index: e.realIndex,
                    id: addresses.address[e.realIndex].id,
                  });
                }}
              >
                {addresses.length > 0
                  ? addresses
                    .sort((a, b) => Number(b.address.isPrincipal) - Number(a.address.isPrincipal))
                    .map((address, index) => (
                      <SwiperSlide>
                        <div className="px-5">
                          <FAddressCard
                            address={address}
                            className="text-[3vw] smm:text-[14px] cursor-grab active:cursor-grabbing"
                          />
                        </div>
                      </SwiperSlide>
                    ))
                  : null}
              </Swiper>
              <div
                className="border-0 w-full font-bold text-Secondary text-[4vw] smm:text-[17px] grid place-items-end cursor-pointer"
                onClick={() => {
                  saveState()
                  setPreviousScreenDefinite(-1);
                  route("/CreateAddressScreen");
                }}
              >
                Agregar nueva dirección
              </div>
            </div>
          ) : (
            <div className="border-0 col-span-1">
              <div
                className="border-3 grid grid-cols-1 rounded-2xl py-2 my-2 shadow-Box cursor-pointer"
                onClick={() => {
                  setPreviousScreenDefinite(-1);
                  saveState()
                  route("/CreateAddressScreen");
                }}
              >
                <div className="border-0 col-span-1 grid place-items-center">
                  <LocationOutline width="35px" height="35px" />
                </div>
                <div className="border-0 col-span-1 text-center font-semibold text-[3.5vw] smm:text-[15px]">
                  Agregar dirección
                </div>
              </div>
              <p className="text-error font-bold text-left text-small">
                {errors.pan}
              </p>
            </div>
          )}
          {emailMapSelect.length > 0 ? (
            <>
              <div className="border-0 col-span-1 z-50 grid grid-cols-12">
                <div className="border-0 col-span-12">
                  {!emailMapSelect ? null : (
                    <Fselect
                      type="SelectIcon"
                      title="Selecciona tu Email"
                      placeholder="Selecciona tu Email"
                      value={emailMapSelect[emailMapSelect.length - 1]}
                      options={emailMapSelect}
                      onChange={(value) => {
                        setFieldValue("contactInfoId", value.id);
                      }}
                    />
                  )}
                </div>
              </div>

              <div
                className="border-0 w-full font-bold text-Secondary text-[4vw] smm:text-[17px] py-2 grid place-items-end cursor-pointer"
                onClick={() => {
                  setPreviousScreenDefinite(-1);
                  saveState()
                  route("/CreateEmailScreen");
                }}
              >
                Agregar nuevo email
              </div>
            </>
          ) : (
            <div className="border-0 col-span-1">
              <div
                className="border-3 grid grid-cols-1 rounded-2xl py-2 my-2 shadow-Box cursor-pointer"
                onClick={() => {
                  setPreviousScreenDefinite(-1);
                  saveState()
                  route("/CreateEmailScreen");
                }}
              >
                <div className="border-0 col-span-1 grid place-items-center">
                  <MailOutline width="35px" height="35px" />
                </div>
                <div className="border-0 col-span-1 text-center font-semibold text-[3.5vw] smm:text-[15px]">
                  Agregar correo
                </div>
              </div>
              <p className="text-error font-bold text-left text-small">
                {errors.contactInfoId}
              </p>
            </div>
          )}
          <div className="border-0 col-span-1">
            <Fbutton
              value="Continuar"
              disabled={!(isValid && dirty)}
              onClick={handleSubmit}
            />
          </div>
        </div>
      </FContainer>
    </>
  );
};

export default CreateCardScreen;
